<template>
	<div class="display-flex flex-column flex-justify-center">
		<div v-if="!isPlacementMode" class="location-description">SPACE</div>
		<div class="project-selector-title first-letter-uppercase flex-row display-flex flex-align-center">
			<template v-if="isPlacementMode">
				<AppIcon class="mr-2" v-if="slug" :name="slug" width="16" height="16" />
			</template>
			<template v-else>
				<SpaceIconCard class="mr-2">
					<AppIcon width="10" height="10" :name="projectIconIndicatorName" />
				</SpaceIconCard>
			</template>
			<span class="one-row">{{ title }}</span>
		</div>
	</div>
</template>

<script>
import SpaceIconCard from '@/views/AppLayout/ManageAndCreate/SpaceIconCard.vue';
export default {
	name: 'ProjectSelectorTitle',
	components: { SpaceIconCard },
	props: {
		slug: { type: String },
		title: { type: String },
		description: { type: String },
		isPlacementMode: { type: Boolean },
		isPersonalProject: { type: Boolean },
		isEverythingProject: { type: Boolean },
		isSharedWithMeProject: { type: Boolean },
	},
	computed: {
		projectIconIndicatorName() {
			if (this.isEverythingProject) {
				return 'all-projects';
			} else if (this.isSharedWithMeProject) {
				return 'shared-with-me';
			} else {
				return `${this.isPersonalProject ? 'personal' : 'collaborative'}-space`;
			}
		},
	},
};
</script>
<style scoped lang="scss">
.project-selector-title {
	font-size: 14px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
}
.description {
	font-size: 12px;
}
.location-description {
	font-size: 11px;
	color: var(--Colors-Neutral-Text-colorTextTertiary, #c1c5cf);
}
</style>
